export async function loadChartScript() {
  return new Promise((resolve) => {
    function check() {
      if (window.Chart) {
        resolve();
      } else {
        setTimeout((() => check(), 250));
      }
    }
    if (document.getElementById('script.js')) {
      check();
    } else {
      const script = document.createElement('script');
      script.id = 'chart.js';
      script.src = '/wp-content/themes/ppro/assets/scripts/chart-js/chart.min.js';
      script.addEventListener('load', () => check());
      document.head.append(script);
    }
  });
}

export async function loadLottieScript() {
  return new Promise((resolve) => {
    function check() {
      if (window.bodymovin) {
        resolve();
      } else {
        setTimeout((() => check(), 250));
      }
    }
    if (document.getElementById('lottie.js')) {
      check();
    } else {
      const script = document.createElement('script');
      script.id = 'lottie.js';
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.7.11/lottie.min.js';
      script.addEventListener('load', () => check());
      document.head.append(script);
    }
  });
}